import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="performances--column-toggle"
export default class extends Controller {
  static values = {
    storageKey: { type: String, default: 'performances-toggle-states' }
  }

  connect() {
    this.loadToggleStates()
  }

  toggleAct(event) {
    this.toggleColumn('act', event.target.checked)
  }

  toggleOver(event) {
    this.toggleColumn('over', event.target.checked)
  }

  toggleNight(event) {
    this.toggleColumn('night', event.target.checked)
  }

  toggleHol(event) {
    this.toggleColumn('hol', event.target.checked)
  }

  toggleColumn(type, show) {
    const headers = document.querySelectorAll(`.th-${type}`)
    const cells = document.querySelectorAll(`.td-${type}`)
    const cols = document.querySelectorAll(`.col-${type}`)

    headers.forEach(el => el.classList.toggle('hide-col', !show))
    cells.forEach(el => el.classList.toggle('hide-col', !show))
    cols.forEach(el => el.classList.toggle('hide-col', !show))

    this.saveToggleState(type, show)
  }

  saveToggleState(type, checked) {
    const states = this.getToggleStates()
    states[type] = checked
    sessionStorage.setItem(this.storageKeyValue, JSON.stringify(states))
  }

  loadToggleStates() {
    const types = ['act', 'over', 'night', 'hol']
    const checkboxIds = {
      act: 'toggleActual',
      over: 'toggleOvertime',
      night: 'toggleNight',
      hol: 'toggleHoliday'
    }

    const states = this.getToggleStates()

    types.forEach(type => {
      const isChecked = states[type] || false
      const checkbox = document.getElementById(checkboxIds[type])

      if (checkbox) {
        checkbox.checked = isChecked
        this.toggleColumn(type, isChecked)
      }
    })
  }

  getToggleStates() {
    const saved = sessionStorage.getItem(this.storageKeyValue)
    return saved ? JSON.parse(saved) : {}
  }

  clearStates() {
    sessionStorage.removeItem(this.storageKeyValue)
  }
}
